import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import DateUtils from "src/services/utils/DateUtils";

import styles from "../../styles";
import { EntityRecordsTable, KeyValueTable, SectionTitle, SubSectionTitle } from "../../shared";
import {
    buildBasicInfoRows,
    buildContactRecords,
    buildFinancialRows,
    buildLocationRecords,
    buildManagementRecords,
    buildMetadataRows,
    buildShareholderRecords,
    CONTACT_COLUMNS,
    LOCATION_COLUMNS,
    MANAGEMENT_COLUMNS,
    mapRows,
    SHAREHOLDER_COLUMNS,
} from "./rows";

const BasicCompanyInformationSection = ({ t, supplierData = {}, meta }) => {
    const dateUtils = new DateUtils();
    const supplierDetail = supplierData?.supplierDetail || {};
    const child = meta?.child || {};
    const locationRecords = buildLocationRecords(supplierDetail?.locations).map((record) => ({
        ...record,
        type: record.type ? t(record.type) : record.type,
    }));

    return (
        <View style={styles.wordSectionContent}>
            <KeyValueTable
                leading={(
                    <SectionTitle
                        title={meta?.title || "Basic Company Information"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
                rows={mapRows(buildBasicInfoRows(supplierDetail))}
                titleColumnLabel="Field"
                detailsColumnLabel="Information"
            />

            <EntityRecordsTable
                leading={(
                    <SubSectionTitle
                        title={child.address?.title || "Address"}
                        number={child.address?.number}
                        anchorId={child.address?.anchorId}
                    />
                )}
                columns={LOCATION_COLUMNS}
                records={locationRecords}
            />

            <EntityRecordsTable
                leading={(
                    <SubSectionTitle
                        title={child["contact-information"]?.title || "Contact Information"}
                        number={child["contact-information"]?.number}
                        anchorId={child["contact-information"]?.anchorId}
                    />
                )}
                columns={CONTACT_COLUMNS}
                records={buildContactRecords(supplierData?.contactPersons)}
            />

            <EntityRecordsTable
                leading={(
                    <SubSectionTitle
                        title={child.shareholders?.title || "Shareholders"}
                        number={child.shareholders?.number}
                        anchorId={child.shareholders?.anchorId}
                    />
                )}
                columns={SHAREHOLDER_COLUMNS}
                records={buildShareholderRecords(supplierData?.shareHolders)}
            />

            <EntityRecordsTable
                leading={(
                    <SubSectionTitle
                        title={child["management-team"]?.title || "Management Team"}
                        number={child["management-team"]?.number}
                        anchorId={child["management-team"]?.anchorId}
                    />
                )}
                columns={MANAGEMENT_COLUMNS}
                records={buildManagementRecords(supplierData?.teamManagement, dateUtils)}
            />

            <KeyValueTable
                leading={(
                    <SubSectionTitle
                        title={child["financial-summary"]?.title || "Financial Summary"}
                        number={child["financial-summary"]?.number}
                        anchorId={child["financial-summary"]?.anchorId}
                    />
                )}
                rows={mapRows(buildFinancialRows(supplierDetail))}
                titleColumnLabel="Metric"
                detailsColumnLabel="Value"
            />

            <KeyValueTable
                leading={(
                    <SubSectionTitle
                        title={child.metadata?.title || "Metadata"}
                        number={child.metadata?.number}
                        anchorId={child.metadata?.anchorId}
                    />
                )}
                rows={mapRows(buildMetadataRows(supplierDetail, dateUtils))}
                titleColumnLabel="Field"
                detailsColumnLabel="Value"
            />
        </View>
    );
};

export default withNamespaces()(BasicCompanyInformationSection);
